import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'

Vue.use(ElementUI)
Vue.config.productionTip = false

// 在开发环境下使用Mock
if (process.env.NODE_ENV === 'development') {
  require('./mock/purchase')
}

axios.defaults.baseURL = '/api'  // 设置基础URL

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app') 